var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame211(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#20A3BA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.54 41.08C23.9267 38.36 26.58 36.1333 28.5 34.4C30.42 32.64 32.0333 30.8133 33.34 28.92C34.6733 27 35.34 25.12 35.34 23.28C35.34 21.5467 34.9133 20.1867 34.06 19.2C33.2333 18.1867 31.8867 17.68 30.02 17.68C28.2067 17.68 26.7933 18.2533 25.78 19.4C24.7933 20.52 24.26 22.0267 24.18 23.92H20.66C20.7667 20.9333 21.6733 18.6267 23.38 17C25.0867 15.3733 27.2867 14.56 29.98 14.56C32.7267 14.56 34.9 15.32 36.5 16.84C38.1267 18.36 38.94 20.4533 38.94 23.12C38.94 25.3333 38.2733 27.4933 36.94 29.6C35.6333 31.68 34.14 33.52 32.46 35.12C30.78 36.6933 28.6333 38.5333 26.02 40.64H39.78V43.68H20.54V41.08Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame211);
export default __webpack_public_path__ + "static/media/Frame 21 (1).0e50a9001aa004207c46b398ac30bbbd.svg";
export { ForwardRef as ReactComponent };